import { IYaraRuleset } from "./yaraRuleset";

export type ThreatCount = {
  count: number;
  threat: number;
};

export type NamedThreatCount = {
  name: string;
  total_unknown: number;
  total_goodware: number;
  total_suspicious: number;
  total_malicious: number;
};

export type NamedThreatCountChartData = {
  name: string;
  unknown: number;
  goodware: number;
  suspicious: number;
  malicious: number;
};

export type YaraSample = {
  id: number;
  file_count: number;
  downloadable: boolean;
  first_seen: string;
  last_seen: string;
  samplerule_ids: number[];
  created: string;
  sample_id: number;
  rule: string;
  message: string;
  file_size: number;
  sha1: string;
  sha256: string;
  md5: string;
  type_display: string;
  cloud: boolean;
  filename: string;
  threat_name: null;
  exceeds_max_file_size: boolean;
  threat_status: number;
  location: number;
  state: number;
  factor: number;
  username: string;
  submission_date?: string;
  string_match_count: number | null;
};

export interface GetYaraSamplesRefData {
  total_rows: number;
  threat_counts: ThreatCount[];
  file_sizes: NamedThreatCount[];
  file_formats: NamedThreatCount[];
  rules: NamedThreatCount[];
  threat_types: NamedThreatCount[];
  threat_type_options: string[];
  file_format_options: string[];
  selected_revision_summary?: IYaraRuleset;
  active_revision_summary?: IYaraRuleset;
}

export interface GetYaraSamplesResponse extends GetYaraSamplesRefData {
  rows: YaraSample[];
  pageSize: number;
}

export type YaraRevisionInfo = {
  malicious: number;
  suspicious: number;
  goodware: number;
  unknown: number;
  timestamp: string;
  value: number;
  text: string;
  retrohunt_status: number;
  retrohunt_start_time: string | null;
  retrohunt_finish_time: string | null;
  online_source_commit_id?: string;
};

export interface GetYaraRevisionHistoryForRulesetResponse {
  items: YaraRevisionInfo[] | null;
  success: boolean;
}

export type YaraRuleOption = {
  text: string;
  value: string | null;
};

export interface GetYaraRulesForRevisionResponse {
  items: YaraRuleOption[];
  success: boolean;
}

export interface GetYaraRevisionDetailsResponse {
  success: boolean;
  details: {
    id: number;
    from_core: boolean;
    from_paranoid: boolean;
    is_active: boolean;
    name: string;
    content: string;
    saved_in_cloud: boolean;
    info_active: string;
    info_added: string;
    info_edited: string;
    always_save: boolean;
    is_disabled: boolean;
    is_editing_disabled: boolean;
    is_pending: boolean;
    is_published_to_sdm: boolean;
  };
}

export type YaraSampleRowGridItem = {
  uuid: string;
  id: number;
  file_count: number;
  downloadable: boolean;
  first_seen: string;
  last_seen: string;
  samplerule_ids: number[];
  created: string;
  sample_id: number;
  rules: string;
  message: string;
  sample_size: number;
  sha1: string;
  sha256: string;
  md5: string;
  sample_type: string;
  cloud: boolean;
  threat_name: null;
  exceeds_max_file_size: boolean;
  threat_status: string;
  location: string;
  state: number;
  factor: number;
  username: string;
  string_submissions_user: string[];
  string_sample_processing_status: string;
  integer_submissions: number;
  sample_available: boolean;
  date_submission_time?: string;
  file_name: string;
  string_match_count: number | null;
  rulesetName?: string;
};

export interface YaraDetailsQueryParams {
  classification?: string;
}

export interface YaraMatchesResponse {
  matches: YaraSample[];
}

export interface IYaraStatusControlsData {
  ruleset: {
    name: string;
    content: string;
    enabled: boolean;
    ticloud: boolean;
    publish: boolean;
  };
  id: number;
}
